import './index.scss'

wp.blocks.registerBlockStyle( 
  'core/template-part',
  {
    name: 'template-part-absolute',
    label: 'Absolute Header'
  }
);


wp.blocks.registerBlockStyle( 
  'core/template-part',
  {
    name: 'template-part-sticky',
    label: 'Sticky Header'
  }
);